import type { Modal } from '@ps/web-core-store';
import { StarsButton, Translation } from '@ps/web-shared-components';
import { StarsLink } from '@ps/web-shared-ui';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';

import useFormatEventDate from '../../hooks/useFormatEventDate';
import type { Pass } from '../../types';
import { ModalRoutes } from '../../types';

import { TXTCLI_Event_Info, TXTCLI_Redeem_3, TXTCLI_See_Bundle } from './Card.messages.json';
import styles from './Card.scss';

const Card = ({ name, image, awards, value, event, type, tournId, redemptionType }: Pass) => {
  const { modal } = useDispatch<Dispatch>();
  const isAuthenticated = useSelector(select.session.isAuthenticated);

  const { startDate, endDate, infoUrl, eventType } = event;
  const formattedEventDate = useFormatEventDate({ startDate, endDate, eventType });

  const handleOpenRedeemModal = () => {
    const locationParams: Modal = {
      path: ModalRoutes.RedeemPassWizard,
      locationState: {
        name,
        formattedEventDate,
        image,
        type,
        tournId,
        redemptionType
      }
    };

    modal.enqueue(
      isAuthenticated ? locationParams : { path: '/auth/login', locationState: locationParams }
    );
  };

  const handleOpenBundle = () =>
    modal.enqueue({
      path: ModalRoutes.PassBundle,
      locationState: { passAwards: awards, type, name, value, redemptionType }
    });

  return (
    <div className={styles.card}>
      <div className={styles.cardImageWrapper}>
        <img src={image} alt={name} className={styles.cardImage} />
      </div>
      <div className={styles.cardInformation}>
        <div>
          <div className={styles.cardTitle}>{name}</div>
          <div className={styles.cardEventInfo}>
            <div className={styles.cardDate}>{formattedEventDate}</div>
            <StarsLink target="_blank" href={infoUrl} className={styles.cardButtonLink}>
              <Translation {...TXTCLI_Event_Info} tagName="span" />
            </StarsLink>
          </div>
        </div>
        <hr className={styles.cardHr} />
        <div className={styles.buttonWrapper}>
          <StarsButton
            className={styles.cardButton}
            translation={TXTCLI_See_Bundle}
            onClick={handleOpenBundle}
          />
          <StarsButton
            className={styles.cardButton}
            translation={TXTCLI_Redeem_3}
            onClick={handleOpenRedeemModal}
          />
        </div>
      </div>
    </div>
  );
};

export default Card;
